<template>
    <div id="list-silo-equipment-component" class="pa-4">
        <in-progress-component/>
    </div>
</template>

<script>
import InProgressComponent from "@/components/Error/InProgressComponent";

export default {
    name: "ListSiloEquipmentComponent",
    components: {InProgressComponent}
}
</script>